import { HStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import CanopyButton from '../../../../canopy-ui-components/components/CanopyButton/CanopyButton';
import * as ga from '../../../../canopy-ui-components/google-analytics';
import { useCheckForMobile } from '../../../../canopy-ui-components/hooks/UseResponsive/UseResponsive';
import DeleteFileModal from './DeleteFileModal';
import EditFileModal from './EditFileDetailsModal';

function DocumentsAction({
    globalProps,
    selectedFlatRows,
    refreshData,
    layoutState,
}: any) {
    const [showFileEditModal, setShowFileEditModal] = useState(false);
    const [showFileDeleteModal, setShowFileDeleteModal] = useState(false);
    const isMobile = useCheckForMobile();
    const getSelectedRows = (selectedFlatRows: any[]) => {
        let selectedRows: any = [];
        if (Array.isArray(selectedFlatRows)) {
            selectedFlatRows?.forEach(({ original, originalSubRows }: any) => {
                if (originalSubRows.length) {
                    selectedRows = selectedRows.concat([
                        ...originalSubRows.map((item: any) => ({
                            ...item,
                            templateName: original?.fileName,
                        })),
                    ]);
                } else if (
                    !selectedRows?.find(
                        ({ documentId }: any) =>
                            documentId === original?.documentId
                    )
                ) {
                    selectedRows = selectedRows.concat([original]);
                }
            });
        } else {
            const { original, originalSubRows }: any = selectedFlatRows;
            if (originalSubRows.length) {
                selectedRows = selectedRows.concat([...originalSubRows]);
            } else if (
                !selectedRows?.find(
                    ({ documentId }: any) => documentId === original?.documentId
                )
            ) {
                selectedRows = selectedRows.concat([original]);
            }
        }
        return selectedRows;
    };

    const getAccountSetUpFiles = (selectedFlatRows: any[]) => {
        if (Array.isArray(selectedFlatRows)) {
            return selectedFlatRows?.filter(
                ({ original }: any) =>
                    original?.fileType === 'account_setup' ||
                    original?.customTagValue?.find(
                        ({ tagValue }: any) =>
                            tagValue === 'canopy_ul_for_upload'
                    )
            );
        }
    };

    const handleEditFile = () => {
        ga.event({
            action: `${window.location.pathname.replace('//g/', '')} > Edit`,
        });
        setShowFileEditModal(true);
    };
    const handleDeleteFile = () => {
        ga.event({
            action: `${window.location.pathname.replace('//g/', '')} > Delete`,
        });
        setShowFileDeleteModal(true);
    };

    const files: any = React.useMemo(
        () => getSelectedRows(selectedFlatRows),
        [selectedFlatRows]
    );

    const accountSetupFiles: any = React.useMemo(() => {
        return getAccountSetUpFiles(selectedFlatRows);
    }, [selectedFlatRows]);

    if (files?.length) {
        return (
            <>
                <HStack spacing="15px">
                    {!isMobile ? (
                        <CanopyButton
                            height="30px"
                            width="140px"
                            fontSize="sm"
                            fontWeight="bold"
                            variant="solid"
                            onClick={handleEditFile}
                            size="sm">
                            {globalProps.t('ui.mm.tooltip.edit-file-details', {
                                count: files?.length,
                            })}
                        </CanopyButton>
                    ) : null}
                    <CanopyButton
                        height="30px"
                        width="140px"
                        fontSize="sm"
                        fontWeight="bold"
                        variant="solid"
                        onClick={handleDeleteFile}
                        size="sm">
                        {globalProps.t('delete')}
                    </CanopyButton>
                </HStack>
                {showFileEditModal && (
                    <EditFileModal
                        userId={layoutState?.user_id}
                        data={files}
                        showModal={showFileEditModal}
                        setShowModal={setShowFileEditModal}
                        refreshData={refreshData}
                        globalProps={globalProps}></EditFileModal>
                )}
                {showFileDeleteModal ? (
                    <DeleteFileModal
                        userId={layoutState?.user_id}
                        data={files}
                        showModal={showFileDeleteModal}
                        setShowModal={setShowFileDeleteModal}
                        refreshData={refreshData}
                        globalProps={globalProps}></DeleteFileModal>
                ) : null}
            </>
        );
    }
    return null;
}
export default DocumentsAction;
